export default "__VITE_ASSET__Vwk2Rw1M__"